import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  UnlockOpportunities,
  ModalWithOverlay,
  ScrollToTopOnMount,
} from '../coreui';

import Hero from './hero';
import ExploreOpportunities from './exploreOpportunities';
import InvestmentPlatform from './investmentPlatform';
import EarnPassiveIncome from './earnPassiveIncome';
import RightOpportunities from './rightOpportunities';
import RecentInvestments from './recentInvestments';
import PressMentions from './pressMentions';

class Homepage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false,
      modalContent: null,
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal(modalContent) {
    this.setState({
      isModalVisible: !this.state.isModalVisible,
      modalContent: this.state.isModalVisible ? null : modalContent,
    });
  }

  render() {
    const {
      isModalVisible,
      modalContent,
    } = this.state;

    const {
      user,
      totalMembers,
      totalAmountFinanced,
      amountPaidOut,
    } = this.props;

    return (
      <React.Fragment>
        <ScrollToTopOnMount />
        <Hero
          isLoggedIn={user.isLoggedIn}
        />
        <ExploreOpportunities
          totalMembers={totalMembers}
          totalAmountFinanced={totalAmountFinanced}
          amountPaidOut={amountPaidOut}
        />
        <InvestmentPlatform
          isLoggedIn={user.isLoggedIn}
        />
        <EarnPassiveIncome
          toggleModal={this.toggleModal}
          passiveIncomeNum={amountPaidOut}
        />
        <RightOpportunities
          isLoggedIn={user.isLoggedIn}
        />
        <RecentInvestments />
        <PressMentions />
        <UnlockOpportunities
          isLoggedIn={user.isLoggedIn}
        />
        <ModalWithOverlay
          isVisible={isModalVisible}
          handleClick={this.toggleModal}
        >
          {modalContent}
        </ModalWithOverlay>

      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.homepage.user,
  totalMembers: state.homepage.totalMembers,
  totalAmountFinanced: state.homepage.totalAmountFinanced,
  amountPaidOut: state.homepage.amountPaidOut,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

Homepage.propTypes = {
  user: PropTypes.object,
  totalMembers: PropTypes.number,
  totalAmountFinanced: PropTypes.number,
  amountPaidOut: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
